// 8 performance advertising services
const services = [
  {
    slug: "paid-search",
    code: "SVC.01",
    title: "Paid Search",
    short: "Google Ads, Bing Ads, Apple Search Ads — managed against profit, not impression share.",
    detail: "Search is the channel that converts; it's also the channel agencies hide poor work in by buying brand traffic. We run paid search separated by intent — branded, generic, competitor, content — with profit-per-click visibility at the SKU level.",
    deliverables: [
      "Campaign architecture separated by intent tier",
      "Smart Bidding strategies tuned to profit, not revenue",
      "SKU-level profitability instrumentation",
      "Negative keyword and search-term hygiene at weekly cadence",
      "Apple Search Ads for app marketers, integrated to MMP"
    ]
  },
  {
    slug: "paid-social",
    code: "SVC.02",
    title: "Paid Social",
    short: "Meta, TikTok, LinkedIn, Reddit, Snap — creative velocity matched to platform appetite.",
    detail: "Paid social fails when the creative cadence does not match the platform's appetite. We deliver creative in volume — locally produced, tested, archived — and manage spend across the platforms with daily eyes-on optimisation.",
    deliverables: [
      "Channel-mix planning by audience density per platform",
      "Creative production in volume (still, motion, UGC)",
      "Audience layering: lookalikes, retargeting, lifecycle",
      "Daily account management and pacing",
      "Cross-platform measurement reconciled in our warehouse"
    ]
  },
  {
    slug: "programmatic-display",
    code: "SVC.03",
    title: "Programmatic Display",
    short: "DV360, The Trade Desk, Xandr — open-web inventory bought with intent, not impressions.",
    detail: "Programmatic at scale rewards transparency. We trade through DV360 or The Trade Desk, build PMP deals against curated inventory, and report against viewability and incremental conversion — not on vendor-reported reach numbers.",
    deliverables: [
      "DSP selection, deal-ID setup and inventory curation",
      "Audience segmentation via 1P / 2P / 3P data",
      "Viewability and brand-safety guarantees in writing",
      "Frequency capping across overlapping DSPs",
      "Lift-tested programmatic budgets, not last-click optimised"
    ]
  },
  {
    slug: "ctv",
    code: "SVC.04",
    title: "Connected TV",
    short: "OTT and CTV inventory bought programmatically — measured against household-level reach.",
    detail: "CTV closes the gap between TV reach and digital measurement. We plan and execute CTV via Roku, Samsung Ads, NBC Peacock and the long tail of OTT inventory, with co-viewing and household identity baked into the measurement model.",
    deliverables: [
      "Inventory plan across walled-garden and open CTV",
      "Creative versioning for non-skippable 15s / 30s",
      "Household identity and co-viewing measurement",
      "Multi-touch attribution that credits CTV correctly",
      "Cross-screen frequency caps and reach reporting"
    ]
  },
  {
    slug: "retail-media",
    code: "SVC.05",
    title: "Retail Media",
    short: "Amazon Ads, Trendyol Ads, Hepsiburada Ads, Walmart Connect — bought against share-of-shelf.",
    detail: "Retail media networks have become the third-largest digital ad pool. We run retail-media specifically — bidding against share-of-shelf, attributing to in-platform conversion, and managing the inventory + content + advertising trio as one motion.",
    deliverables: [
      "Account, catalog and content optimisation",
      "Sponsored Products, Sponsored Brands and DSP campaigns",
      "Retail-media planning against share-of-shelf targets",
      "Seasonal commercial planning aligned to platform calendars",
      "Weekly trading reviews against ROAS and contribution"
    ]
  },
  {
    slug: "creative-testing",
    code: "SVC.06",
    title: "Creative Testing",
    short: "Production at velocity — variant testing, fatigue tracking, the creative library that lasts.",
    detail: "Modern paid social demands new creative every few days, not every few campaigns. We run a creative test-and-learn programme — production in batches, structured variant testing, fatigue tracking — feeding the channel teams faster than they can burn the assets.",
    deliverables: [
      "Creative concepting and weekly production cadence",
      "Variant testing with statistical power calculations",
      "Creative library and tag-based asset management",
      "Fatigue tracking and proactive refresh schedule",
      "Insight readouts shared with brand and product teams"
    ]
  },
  {
    slug: "cro",
    code: "SVC.07",
    title: "Conversion Optimisation",
    short: "Landing pages, signup flows, checkout — engineered to reduce the leak before scaling spend.",
    detail: "Conversion optimisation is where most paid media campaigns find their next 30%. We run structured CRO across landing pages, signup flows, onboarding and checkout — testing in volume, capturing every result.",
    deliverables: [
      "Funnel audit and friction-point identification",
      "Hypothesis backlog and test prioritisation framework",
      "Landing page, signup and checkout experimentation",
      "Test design with statistical power and predefined holdouts",
      "Quarterly reporting on validated lift and capitalised gains"
    ]
  },
  {
    slug: "attribution",
    code: "SVC.08",
    title: "Attribution & Measurement",
    short: "MTA, MMM and incrementality — built so the finance team actually trusts the numbers.",
    detail: "We rebuild measurement so the CFO and the CMO see the same number. Multi-touch attribution where it makes sense, media-mix modelling where it does not, structured incrementality testing on top.",
    deliverables: [
      "MTA model build and validation against test data",
      "Media-mix modelling on first-party + platform data",
      "Geo-holdout and conversion-lift testing programmes",
      "Finance-grade reporting in CFO language",
      "Quarterly readouts with documented methodology"
    ]
  }
];

export default services;
export const getService = (slug) => services.find((s) => s.slug === slug) || null;
